export const globalVars = {
    BACKEND_URL: 'https://cse412-pages.onrender.com'
};